<survey [model]="survey" [class.readonly]="survey.readOnly" [class.compact]="compact" />
